export const MICROSITE_TENANTS = new Set([
  "langchain_co_in",
  "langchain_biz",
  "deep_learning_co_in",
  "deeplearningcourse_co_in",
  "deeplearningcourse_online",
  "nlpcourse_online",
  "nlpcourse_co_in",
  "nlpcourse_ai",
  "naturallanguageprogramming_in",
  "promptengineeringcourse_in",
  "promptengineeringcourse_co_in",
  "agenticaicourse_com",
  "agenticaicourse_in",
  "agenticaicourse_online",
  "agenticaicourse_co_in",
  "aipromptengineering_online",
  "aipromptengineering_co_in",
  "aipromptengineering_ai",
]);
